import AthleteManagment from './AthleteManagment';

export default AthleteManagment;
